export default __webpack_public_path__ + "static/media/CAPA_BLUE_MEDIUM.b9decb32.svg";